import { render, staticRenderFns } from "./BranchInfoPanel.vue?vue&type=template&id=34c95034&scoped=true&"
import script from "./BranchInfoPanel.vue?vue&type=script&lang=js&"
export * from "./BranchInfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c95034",
  null
  
)

export default component.exports